<template>
    <div v-if="visible"></div>
</template>

<script>

import {
  API
} from '../utils/api'
import {
  w
} from '../utils/helpers'
import {
  mapGetters
} from 'vuex'

//const loc = window.location
const origin = '*'

export default {
  created() {

    if (this.isSwayChatPopout) {

      window.addEventListener('beforeunload', this.sendCloseEvent)
      document.title = "SwayChat"

      if (opener)
        this.sendOpenEvent()

      API.$on('visitorConnected', this.connected)

    } else {
      window.addEventListener('message', this.listen)
    }
    API.$on('popOutOpen', this.open)
    API.$on('popOutClose', this.close)

  },
  computed: {
      ...mapGetters([
        'allowPopOut',
        'isMinimize',
        'isPopout',
        'getWidgetId',
        'getOrgId',
        'getStartUpMode',
        'isSwayChatPopout'
      ])
  },
  methods: {
    open() {

      if (this.isPopout ||
        !this.allowPopOut
      )
      return

      const pw = 320
      const ph = 480
      const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left
      const dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top
      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height
      const left = ((width / 2) - (pw / 2)) + dualScreenLeft
      const top = ((height / 2) - (ph / 2)) + dualScreenTop

      let url = w.app('popout')

      this.popout = window.open(url, 'Test', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + pw + ', height=' + ph + ', top=' + top + ', left=' + left)
      if (this.popout)
        this.popout.focus()

    },
    connected() {
      if (document.hasFocus())
        this.$store.dispatch('doPopout', true)
    },
    listen(e) {
      if (e
        && e.data
        && e.data.popout
        && e.origin.indexOf('@@CDN') > 0
      ) {

        const cmd = e.data.popout

        if (cmd == 'close')
          this.close()

        if (cmd == 'open' && this.popout)
          this.$store.dispatch('doPopout', true)

      }
    },
    close() {
      this.$store.dispatch('doPopout', false)
    },
    sendCloseEvent() {
      API.$emit('popOutClose')
      if (opener) {
        opener.postMessage({
          popout: 'close'
        }, origin)
      }
    },
    sendOpenEvent() {
      if (opener) {
        opener.postMessage({
          popout: 'open'
        }, origin)
      }
    }
  }
}

</script>
